module.exports = __webpack_public_path__ + "static/media/card-view-light.ee7c86e5.svg";